import { useCallback, useMemo } from "react";
import { Column, useSortBy, useTable } from "react-table";
import { FixedSizeList } from "react-window";
import sortUpImg from "../assets/images/Button_Sort_Up.png";
import sortDownImg from "../assets/images/Button_Sort_Down.png";
import "simplebar/dist/simplebar.min.css";
import "./CustomTable.css";

// this uses react-table for table filtering and react-window for virtualization
const CustomTable = ({
  cols,
  rowData,
  handleSelectItem,
  defaultSort,
}: {
  cols: Column[];
  rowData: any[];
  handleSelectItem: (item: any) => void;
  defaultSort?: { id: string; desc: boolean }[];
}) => {
  const columns = useMemo(() => cols, []);
  const rowHeight = 85;
  const tableHeight = 850;

  const sortArr = defaultSort ? defaultSort : [];

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, totalColumnsWidth } = useTable(
    {
      columns: columns,
      data: rowData,
      defaultColumn: {},
      initialState: {
        sortBy: sortArr,
      },
      autoResetSortBy: false,
    },
    useSortBy
  );

  const RenderRow = useCallback(
    ({ index, style }: { index: number; style: React.CSSProperties }) => {
      const row = rows[index];
      prepareRow(row);
      return (
        <div
          {...row.getRowProps({
            style: { ...style, backgroundColor: (index + 1) % 2 === 0 ? "var(--table-row-even-color)" : "white" },
          })}
          className="tableRow pointerCursor"
          onClick={() => {
            handleSelectItem(row.original);
          }}
        >
          {row.cells.map((cell, index) => {
            return (
              <div
                {...cell.getCellProps(props => [
                  props,
                  { style: { flex: cell.column.id === "carWashName" ? 2 : 1, maxWidth: cell.column.maxWidth } },
                ])}
                className="tableCell"
              >
                {cell.render("Cell")}
              </div>
            );
          })}
        </div>
      );
    },
    [prepareRow, rows]
  );

  return (
    <div id="tableContainer">
      <div {...getTableProps()} className="table">
        {/* header */}
        <div>
          {headerGroups.map((headerGroup, index) => (
            <div
              {...headerGroup.getHeaderGroupProps()}
              className="tableHeadersContainer"
              style={{ paddingRight: rowData.length > 10 ? "10px" : "0px" }}
            >
              {headerGroup.headers.map((column, index) => (
                <div
                  {...column.getHeaderProps(props => [
                    column.getSortByToggleProps(),
                    { style: { flex: column.id === "carWashName" ? 2 : 1, maxWidth: column.maxWidth } },
                  ])}
                  className="tableHeader sortableHeader"
                >
                  {column.render("Header")}
                  {column.isSorted ? (
                    column.isSortedDesc ? (
                      <img src={sortDownImg} width="30px" height="30px" />
                    ) : (
                      <img src={sortUpImg} width="30px" height="30px" />
                    )
                  ) : null}
                </div>
              ))}
            </div>
          ))}
        </div>
        {/* body */}
        <div {...getTableBodyProps()} className="body">
          <FixedSizeList
            className="virtualizedList"
            height={tableHeight}
            itemCount={rows.length}
            itemSize={rowHeight}
            width={"100%"}
          >
            {RenderRow}
          </FixedSizeList>
        </div>
      </div>
    </div>
  );
};

export default CustomTable;
